import React, { Dispatch, SetStateAction, useContext, useEffect, useMemo } from "react";
import "./Body.css"
import FilterBar from "./Filter/FilterBar"
import { FilterValue, IndexablePage } from "../../../components/types/types";
import { AppContext } from "../../../context/AppContext";

import HomeView from "./Views/HomeView";
import { HomeRouteMode } from "../hookHomeScreen/useHomeRouteMode";
import { HomeSection } from "../HomeScreen";
import MaskBackgroundOverflow from "../../../components/maskBackground/maskBackgroundOverflow";
import { MainCorpSkeleton } from "./MainCorp/hookMainCorp";
import MainCorp from "./MainCorp/MainCorp";
import { useLocation } from "react-router-dom";

interface BodyInterface {
    mode:HomeRouteMode,
    fetchResto:boolean,
    setShowAll: Dispatch<SetStateAction<number>>,
    cityLoad?:string,
    cityLoadBrut?:string,
    seoPage?: IndexablePage | null;
    
    showAll: number,
    
    homeSections: HomeSection[];
    homeSectionsLoading: boolean;
    homeSectionsRefreshLoading: boolean;

    routeCity: string;
    currentFilter: FilterValue[];
    setCurrentFilter: Dispatch<SetStateAction<FilterValue[]>>;

    fetchSections: (url: string,elem:string, options?: RequestInit, isInitialLoad?: boolean) => void;
    baseSortSection:string,

    showWaitingSearch?:boolean,
    setShowWaitingSearch: React.Dispatch<React.SetStateAction<boolean>>;
    getNeighborhoodResultCount: (neighborhoods: string[]) => number;
}
const Body:React.FC<BodyInterface> = ({mode,cityLoad='',cityLoadBrut='',currentFilter,setCurrentFilter,routeCity,showAll,fetchResto,setShowAll,seoPage,homeSections,homeSectionsLoading,homeSectionsRefreshLoading,fetchSections,baseSortSection,showWaitingSearch=false,getNeighborhoodResultCount,setShowWaitingSearch}) => {
    const {showFilterTel,setShowFilterTel} = useContext(AppContext)

    const viewProps = useMemo(() => ({
        cityLoad,
        cityLoadBrut,
        seoPage,
    }), [cityLoad, cityLoadBrut, seoPage]);

    const location = useLocation();
    const [profileReturnLoading, setProfileReturnLoading] = React.useState(location.state?.fromProfile === true);
    useEffect(() => {
        if (!location.state?.fromProfile) return;

        const timeout = window.setTimeout(() => {
            setProfileReturnLoading(false);
        }, 500);

        return () => window.clearTimeout(timeout);
    }, [location.state?.fromProfile]);


    return (
        <div className="bodyCorp" id="bodyCorp"  >
      
            {showFilterTel &&<>
            <FilterBar currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} showAll={showAll} setShowAll={setShowAll}  routeCity={routeCity} />
            <div className="maskForComputer" onClick={() => setShowFilterTel(false)}><MaskBackgroundOverflow zIndex={50} closeFunction={() => setShowFilterTel(false)}/></div>
            </>}  
            {mode === "home" ? (
                <HomeView setShowWaitingSearch={setShowWaitingSearch} sections={homeSections} loading={homeSectionsLoading} refreshLoading={homeSectionsRefreshLoading} fetchSections={fetchSections} baseSortSection={baseSortSection}/>
                ) : (fetchResto && !showWaitingSearch && !profileReturnLoading)  ? (
                <MainCorp {...viewProps} getNeighborhoodResultCount={getNeighborhoodResultCount} routeCity={routeCity} setCurrentFilter={setCurrentFilter} />
                ) : <MainCorpSkeleton />}
  
        </div>
    )
}

export default Body